import React from "react";
import { Card } from "react-bootstrap";
import {
  FiTrendingUp,
  FiTrendingDown,
  FiAlertTriangle,
  FiUsers,
  FiTarget,
  FiBarChart2,
  FiActivity,
  FiStar
} from "react-icons/fi";

const iconMap = {
  orange: <FiAlertTriangle />,
  purple: <FiUsers />,
  teal: <FiTarget />,
  blue: <FiBarChart2 />,
  pink: <FiActivity />,
  yellow: <FiStar />
};

const colorMap = {
  orange: "#f97316",
  purple: "#a855f7",
  teal: "#0f766e",
  blue: "#3b82f6",
  pink: "#ec4899",
  yellow: "#f59e0b"
};

export default function DealsStatsCard({
  title,
  value,
  percent,
  trend,
  color,
  progress = 60
}) {
  const mainColor = colorMap[color];

  return (
    <Card className="stats-card shadow-sm border-0">
      <Card.Body>

        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <p className="title mb-1">{title}</p>
            <h5 className="value">{value}</h5>
          </div>

          <div
            className="icon-box"
            style={{ background: mainColor }}
          >
            {iconMap[color]}
          </div>
        </div>

        {/* Progress */}
        <div className="progress-bar-custom">
          <div
            className="progress-fill"
            style={{
              width: `${progress}%`,
              background: mainColor
            }}
          ></div>
        </div>

        {/* Trend */}
        <p className={`trend ${trend === "up" ? "up" : "down"}`}>
          {trend === "up" ? <FiTrendingUp /> : <FiTrendingDown />}
          {percent} from last week
        </p>

      </Card.Body>

      {/* CSS */}
      <style>{`
        .stats-card {
          border-radius: 5px;
          background: #fff;
          padding: 8px;
        }

        .title {
          font-size: 14px;
          color: #6b7280;
          font-weight: 500;
        }

        .value {
          font-size: 20px;
          font-weight: 700;
          color: #111827;
        }

        .icon-box {
          width: 44px;
          height: 44px;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
        }

        .progress-bar-custom {
          height: 6px;
          background: #e5e7eb;
          border-radius: 10px;
          overflow: hidden;
          margin: 12px 0;
        }

        .progress-fill {
          height: 100%;
          border-radius: 10px;
        }

        .trend {
          font-size: 13px;
          display: flex;
          align-items: center;
          gap: 6px;
          margin: 0;
        }

        .trend.up {
          color: #16a34a;
        }

        .trend.down {
          color: #dc2626;
        }
      `}</style>
    </Card>
  );
}